import React, { Component } from "react";
import { Training } from "../../../../types/types";
import Service from "../../../../services/workbooks";
import Collapsible from "react-collapsible";
import Exercises from "./exercises/index";
import Options from "./Options";
import Weekday from "../../../../common/Weekday";

type Props = {
    workbook_id: number;
};

type State = {
    trainings: Training[];
    expandedTrainingId: number | null;
    expandedYear: string | null;
};

type TrainingsByYear = {
    [year: string]: Training[];
};

export default class ShowTrainings extends Component<Props, State> {
    constructor(props: Props) {
        super(props);
        this.state = {
            trainings: [],
            expandedTrainingId: null,
            expandedYear: null
        };
    }

    componentDidMount() {
        this.loadTrainings();
    }

    loadTrainings = () => {
        Service.getTrainings(this.props.workbook_id).then((response) => {
            if (response.data.length > 0) {
                const parsedTrainings = response.data
                    .map((training: Training) => {
                        const parsedDate = new Date(training.date)
                            .toISOString()
                            .split("T")[0];
                        return { ...training, date: parsedDate };
                    })
                    .sort(
                        (a: Training, b: Training) =>
                            new Date(b.date).getTime() - new Date(a.date).getTime()
                    );

                const trainingsByYear = this.groupByYear(parsedTrainings);
                const sortedYears = Object.keys(trainingsByYear).sort(
                    (a, b) => Number(b) - Number(a)
                );

                const newestYear = sortedYears[0] ?? null;

                const storedTrainingId = localStorage.getItem("expandedTrainingId");

                this.setState({
                    trainings: parsedTrainings,
                    expandedTrainingId: storedTrainingId
                        ? Number(storedTrainingId)
                        : null,
                    expandedYear: newestYear
                });
            }
        });
    };

    groupByYear(trainings: Training[]): TrainingsByYear {
        return trainings.reduce((acc: TrainingsByYear, training) => {
            const year = new Date(training.date).getFullYear().toString();

            if (!acc[year]) {
                acc[year] = [];
            }

            acc[year].push(training);
            return acc;
        }, {});
    }

    handleYearClick(year: string) {
        this.setState((prevState) => ({
            expandedYear: prevState.expandedYear === year ? null : year
        }));
    }

    handleItemClick(trainingId: number) {
        this.setState((prevState) => ({
            expandedTrainingId:
                prevState.expandedTrainingId === trainingId ? null : trainingId
        }));

        localStorage.setItem("expandedTrainingId", trainingId.toString());
    }

    isItemExpanded(trainingId: number): boolean {
        return this.state.expandedTrainingId === trainingId;
    }

    render() {
        const trainingsByYear = this.groupByYear(this.state.trainings);

        // lata malejąco (2026 → 2025 → 2024)
        const sortedYears = Object.keys(trainingsByYear).sort((a, b) => Number(b) - Number(a));

        return (
            <div>
                <ul>
                    {sortedYears.map((year) => (
                        <li key={year}>
                            {/* COLLAPSIBLE ROKU */}
                            <Collapsible
                                trigger={
                                    <div
                                        style={{ cursor: "pointer", color: "gray", marginBottom: "4px", marginLeft: "4px", fontSize: "0.8rem" }}
                                        onClick={() => this.handleYearClick(year)}
                                    >
                                        {year}
                                    </div>
                                }
                                open={this.state.expandedYear === year}
                            >
                                <ul>
                                    {trainingsByYear[year].map((item: Training) => (
                                        <li key={item.id}>
                                            <Collapsible
                                                trigger={
                                                    <div
                                                        style={{
                                                            cursor: 'pointer',
                                                            display: 'flex',
                                                            alignItems: 'center',
                                                            marginBottom: '10px',
                                                        }}
                                                        onClick={() => this.handleItemClick(item.id)}
                                                    >
                                                        <Options
                                                            trainingId={item.id}
                                                            onTrainingOptionCopy={this.loadTrainings}
                                                            onTrainingOptionDelete={this.loadTrainings}
                                                        />
                                                        &nbsp;&nbsp;
                                                        <Weekday date={item.date} />
                                                        <span> {item.notes} </span>
                                                    </div>
                                                }
                                                open={this.isItemExpanded(item.id)}
                                            >
                                                <Exercises
                                                    workbook_id={item.workbooks_id}
                                                    training_id={item.id}
                                                />
                                            </Collapsible>
                                        </li>
                                    ))}
                                </ul>
                            </Collapsible>
                        </li>
                    ))}
                </ul>
            </div>
        );
    }
}
